import firebaseService from "../firebase/FirebaseService";

export const getFile = async (fileRef) => {
    return firebaseService.getFile(fileRef)
        .then((response) => {
            return response;
        })
        .catch(error => {
            return null;
        });
};